<template>
  <div class="flex justify-between gap-4">
    <slot> </slot>
    <FeatherIcon
      v-if="onAddSubitemsClicked && isTopLevel"
      svgClasses="icon-md"
      class="context-icon"
      icon="PlusIcon"
      @click="() => onAddSubitemsClicked()"
    />
    <FeatherIcon
      v-if="onShowClicked && isHidden"
      svgClasses="icon-md"
      class="context-icon"
      icon="EyeOffIcon"
      @click="() => onShowClicked()"
    />
    <FeatherIcon
      v-if="!isDeleted && onHideClicked && !isHidden"
      svgClasses="icon-md"
      class="context-icon"
      icon="EyeIcon"
      @click="() => onHideClicked()"
    />
    <FeatherIcon
      v-if="onRestoreClicked && isDeleted"
      svgClasses="icon-md"
      class="context-icon"
      icon="RefreshCwIcon"
      @click="() => onRestoreClicked()"
    />
    <FeatherIcon
      v-if="!isHidden && onDeleteClicked && !isDeleted"
      svgClasses="icon-md"
      class="context-icon"
      icon="Trash2Icon"
      @click="() => onDeleteClicked()"
    />
    <FeatherIcon
      v-if="onAddWorkReportClicked"
      svgClasses="icon-md"
      class="context-icon"
      icon="FileTextIcon"
      @click="() => onAddWorkReportClicked()"
    />
  </div>
</template>

<script>
import FeatherIcon from '../FeatherIcon';

export default {
  name: 'TableContext',
  components: {
    FeatherIcon,
  },
  props: {
    isTopLevel: {
      type: [Boolean, Number],
    },
    isHidden: {
      type: [Boolean, Number],
    },
    isDeleted: {
      type: [Boolean, Number],
    },
    onDeleteClicked: Function,
    onHideClicked: Function,
    onShowClicked: Function,
    onRestoreClicked: Function,
    onAddSubitemsClicked: Function,
    onAddWorkReportClicked: Function,
  },
};
</script>

<style scoped>
.context-icon {
  color: #12539e;
  cursor: pointer;
}
</style>
